import { buildRels } from "@src/utils/request"
import url from "url"
import { booomIds, booomLikes } from "@root/data/booomIds"

const included = [
  "user",
  "special-listening-radio",
  "favorite-radio",
  "favorite-topic",
  "first-favorite-category",
  "second-favorite-category",
  "third-favorite-category",
  "first-favorite-album",
  "second-favorite-album",
  "third-favorite-album",
  "first-favorite-collection",
  "second-favorite-collection",
  "third-favorite-collection",
]

export const createPath = (pathname, query) => {
  return url.format({
    pathname,
    query,
  })
}

export const createUserYearPath = (query) => {
  return createPath("user-annual-summaries", {
    ...query,
    include: included.join(","),
  })
}

export const parseGameData = (res) => {
  if (!res.data || !res.included) {
    return null
  }
  const { included } = res
  const games = included.filter(
    (e) => e.type === "games" && booomIds.includes(e.id)
  )
  if (games.length === 0) {
    return null
  }
  const gamesWithScore = games.map((g) => {
    return {
      id: g.id,
      attributes: g.attributes,
      score:
        (booomLikes.find((data) => String(data.id) === g.id)?.like || 0) +
        g.attributes["subscriptions-count"],
    }
  })
  const sortedGames = gamesWithScore.sort((a, b) => b.score - a.score)
  return {
    games,
    amount: games.length,
    image: sortedGames[0].attributes.cover,
    score: gamesWithScore.reduce((sum, { score }) => {
      return sum + score
    }, 0),
  }
}

export const parseData = (res, { myself }) => {
  const builded = buildRels(res)
  console.log("parseData:res", res)
  console.log("parseData:builded", builded)
  if (!builded || builded.length === 0) {
    return null
  }
  const yearData = builded.find((y) => y.attributes.year === 2022)
  const lastYearData = builded.find((y) => y.attributes.year === 2021)
  console.log("parseData:yearData", yearData)
  if (!yearData) {
    return null
  }
  const { attributes, rels } = yearData
  return {
    myself,
    loaded: true,
    token: attributes?.token,

    total: {
      thisYear: attributes["radio-plays-count"],
      spending: attributes["time-spent-listening"],
      compareToLastSpending:
        typeof lastYearData?.attributes["time-spent-listening"] === "number"
          ? attributes["time-spent-listening"] -
            lastYearData.attributes["time-spent-listening"]
          : null,
    },

    categories: [
      rels["first-favorite-category"],
      rels["second-favorite-category"],
      rels["third-favorite-category"],
    ].filter((item) => !!item),
    albums: [
      rels["first-favorite-album"],
      rels["second-favorite-album"],
      rels["third-favorite-album"],
    ].filter((item) => !!item),
    collections: [
      rels["first-favorite-collection"],
      rels["second-favorite-collection"],
      rels["third-favorite-collection"],
    ].filter((item) => !!item),
    attributes,
    ...rels,
  }
}
